"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripStatusStoryCategory = void 0;
exports.TripStatusStoryCategory = {
    CONFIRMATION: 'CONFIRMATION',
    APPROACH_OPE: 'APPROACH_OPE',
    APPROACH_DRIVER: 'APPROACH_DRIVER',
    IN_DA_PLACE_OPE: 'IN_DA_PLACE_OPE',
    IN_DA_PLACE_DRIVER: 'IN_DA_PLACE_DRIVER',
    ON_DUTY_OPE: 'ON_DUTY_OPE',
    ON_DUTY_DRIVER: 'ON_DUTY_DRIVER',
    DONE_OPE: 'DONE_OPE',
    DONE_DRIVER: 'DONE_DRIVER',
    PASSENGER_CANCELLATION: 'PASSENGER_CANCELLATION',
    DRIVER_CANCELLATION: 'DRIVER_CANCELLATION',
    ASK_NO_SHOW: 'ASK_NO_SHOW',
    CONFIRM_NO_SHOW: 'CONFIRM_NO_SHOW',
    ADMIN_CANCELLATION: 'ADMIN_CANCELLATION',
};
